import React, { useEffect, useState } from 'react';
import { currencyByCountry, findPostiveNumber, toAmount } from '../../helpers/Helper';
import './OrderPayout.css';
import { Col, Row } from 'reactstrap';

export const OrderPayout = ({ orderPayout, ReferralCode }) => {
    return (
        <React.Fragment>
            <Row>
                <div className='referral-card'>
                    <div className='price-container'>
                        <p className='font-size-13 fw-normal m-0 ion-text'>Selling Price:</p>
                        <p className='ion-text'>
                            {currencyByCountry(
                                orderPayout?.Payout?.RequoteAmount > 0
                                    ? toAmount(Math.ceil(orderPayout?.Payout?.RequoteAmount))
                                    : toAmount(orderPayout?.Payout?.SuggestedCost),
                            )}
                        </p>
                    </div>
                    {orderPayout?.Payout?.ReferralAmount && (
                        <div className='price-container'>
                            <p className='ion-text'>
                                Promo Bonus <br />
                                ({ReferralCode})
                            </p>
                            <p className='font-size-13 fw-normal m-0 ion-text'>{currencyByCountry(toAmount(orderPayout?.Payout?.ReferralAmount))}</p>
                        </div>
                    )}
                    {orderPayout?.Payout?.Adjustment !== 0 && orderPayout?.Payout?.Adjustment !== null && orderPayout?.Payout?.Adjustment && (
                        <div className='price-container'>
                            <p className='ion-text'>Adjustment</p>
                            <p className={findPostiveNumber(orderPayout?.Payout?.Adjustment)}>
                                {currencyByCountry(toAmount(orderPayout?.Payout?.Adjustment))}
                            </p>
                        </div>
                    )}
                    <hr className='color-white-border' />
                    <div className='price-container'>
                        <p className='ion-text'>Total</p>
                        <p className='ion-text'>{currencyByCountry(toAmount(orderPayout?.Payout?.TotalAmount))}</p>
                    </div>
                </div>
            </Row>
        </React.Fragment>
    );
};